/**
 * Utility to clear Object Manager cache
 *
 * The Object Manager uses localStorage to persist mock data.
 * When new objects are added to the codebase, they won't appear
 * until the cache is cleared because localStorage takes precedence.
 *
 * Usage:
 * 1. Open browser console (F12)
 * 2. Type: clearObjectCache()
 * 3. Press Enter
 * 4. Refresh the page
 */

export const clearObjectManagerCache = () => {
  // Clear objects cache
  localStorage.removeItem('crm_objects');

  // Clear fields cache (in case new fields were added)
  localStorage.removeItem('crm_fields');

  // Clear layouts cache (in case new layouts were added)
  localStorage.removeItem('crm_page_layouts');

  console.log('✅ Object Manager cache cleared!');
  console.log('📦 Cleared: crm_objects, crm_fields, crm_page_layouts');
  console.log('🔄 Refresh the page (F5) to see CSAudit and PAWRecord');

  return 'Cache cleared! Refresh the page.';
};

// Make function available in browser console
if (typeof window !== 'undefined') {
  (window as any).clearObjectCache = clearObjectManagerCache;
}

export default clearObjectManagerCache;
